import * as React from 'react';

import * as styles from './RatingsRedesigned.css';
import { EStarSize, EStarTheme, Star, getPrettyFloat } from '@cian/frontend-reviews-components';
import { ArticleParagraph1 } from '@cian/ui-kit';

export interface IReviewLinkProps {
  onClick?: (event: React.MouseEvent) => void;
  reviewCountText: string;
  totalRate: number;
  reviewCount: number;
}

export function RatingsRedesigned({ reviewCountText, totalRate, reviewCount, onClick }: IReviewLinkProps) {
  const onRatingsClick = React.useCallback(
    (event: React.MouseEvent) => {
      if (onClick) {
        onClick(event);
      }
    },
    [onClick],
  );

  if (reviewCount === 0) {
    return (
      <div className={styles['ratings']} data-testid="HeaderRatings">
        <Star size={EStarSize.M} theme={EStarTheme.NotFilled} />
        <ArticleParagraph1 color="text-main-default">{reviewCountText}</ArticleParagraph1>
      </div>
    );
  }

  return (
    <div onClick={onRatingsClick} className={styles['ratings']} data-testid="HeaderRatings">
      <div className={styles['ratings__label']}>
        <ArticleParagraph1 color="decorative-orange" fontWeight="700">
          {getPrettyFloat(totalRate)}
        </ArticleParagraph1>
      </div>
      <div className={styles['ratings__star']}>
        <Star size={EStarSize.M} theme={EStarTheme.Filled} />
      </div>
      <div className={styles['reviews']}>
        <ArticleParagraph1 color={onClick ? 'text-main-default' : 'black_60'}>{reviewCountText}</ArticleParagraph1>
      </div>
    </div>
  );
}
